import React from 'react';
import { Outlet, useParams } from 'react-router-dom';
import SideBarAdmin from './SideBarAdmin';
import '../../styles/layout.css';

const AdminLayout = ({ children }) => {
  const { slug } = useParams();
 
  return (
    <div className="layout-wrapper">
      <SideBarAdmin slug={slug} />
      <main className="main-content">
 <Outlet />
      </main>
    </div>
  );
};

export default AdminLayout;
